class IntegrationTableController {


    shouldShowEvent (isLinked) {
        return !this.onlyUnlinked || (this.onlyUnlinked && !isLinked);
    }
}

IntegrationTableController.$inject = [];

export default IntegrationTableController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/integration/controllers/integration.table.controller.js